<script>
import { fetchApi } from '@/helpers/fetchApi';

export default {
  name: 'logout',
  watch: {
    $route: {
      immediate: true,
      async handler() {
        const fetch = fetchApi(this);

        const res = await fetch('/auth/logout', {
          method: 'POST',
          withToken: true,
        });

        if (res.ok) {
          this.$cookies.remove('token');
          this.$cookies.remove('user');
        }

        this.$router.push('/');
      },
    },
  },
};
</script>
